import { Optional } from '@pogokid/util'
import {
  DomainEvent,
  NewDomainEvent,
} from '@soniq/public-resource'

export interface SignupAfterAuthCompletedPayload {
  name: string
  invite: Optional<string>
}

export class SignupAfterAuthCompleted extends DomainEvent {
  static readonly event_type = 'signup_after_auth_completed'
  static readonly version = 1

  static new(
    data: Pick<
      NewDomainEvent<SignupAfterAuthCompletedPayload>,
      | 'profile_id'
      | 'user_id'
      | 'correlation_id'
      | 'payload'
      | 'metadata'
    >
  ) {
    const domainEvent = DomainEvent.fromNewPayload({
      profile_id: data.profile_id,
      user_id: data.user_id,
      correlation_id: data.correlation_id,
      aggregate_type: 'profile',
      event_type: SignupAfterAuthCompleted.event_type,
      event_version: SignupAfterAuthCompleted.version,
      payload: data.payload,
      metadata: data.metadata,
    })
    return new SignupAfterAuthCompleted(domainEvent.data)
  }
}
